import { Controller } from '@hotwired/stimulus'
import Chart from 'chart.js/auto'
import {
  ChoroplethController,
  GeoFeature,
  ColorScale,
  ProjectionScale,
} from 'chartjs-chart-geo'
import * as ChartGeo from 'chartjs-chart-geo'
import { stateAbbrToName } from '../utils/geo'

Chart.register(ChoroplethController, GeoFeature, ColorScale, ProjectionScale)

export default class extends Controller {
  static targets = ['canvas']

  static values = {
    data: Object,
  }

  declare readonly dataValue: object
  declare chart: Chart
  declare stateData: Record<string, number>

  canvasContext(): CanvasRenderingContext2D {
    const ctx = (this.element as HTMLCanvasElement).getContext('2d')
    if (!ctx) throw new Error('Canvas 2D context unavailable')
    return ctx
  }

  connect() {
    this.chart = new Chart(this.canvasContext(), {
      type: 'choropleth',
      // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-explicit-any
      data: {} as any,
    })

    this.stateData = {}
    Object.entries(this.dataValue as Record<string, number>).forEach(
      ([key, val]) => {
        this.stateData[stateAbbrToName(key)] = val
      },
    )

    void this.load()
  }

  async load() {
    const resp = await fetch('https://unpkg.com/us-atlas/states-10m.json')
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
    const us = await resp.json()

    /* eslint-disable @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-unsafe-argument, @typescript-eslint/no-explicit-any, @typescript-eslint/no-unsafe-return */
    const nation = (ChartGeo.topojson.feature(us, us.objects.nation) as any)
      .features[0]
    const states = (ChartGeo.topojson.feature(us, us.objects.states) as any)
      .features as any[]

    this.chart.data = {
      labels: states.map((d) => d.properties.name),
      datasets: [
        {
          label: 'States',
          outline: nation,
          data: states.map((d) => ({
            feature: d,
            value: this.stateData[d.properties.name] || 0,
          })),
        },
      ],
    }
    /* eslint-enable @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-unsafe-argument, @typescript-eslint/no-explicit-any, @typescript-eslint/no-unsafe-return */

    this.chart.update()
  }
}
